var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C21 21.1989 20.921 21.3897 20.7803 21.5303C20.6397 21.671 20.4489 21.75 20.25 21.75H3.75C3.55109 21.75 3.36032 21.671 3.21967 21.5303C3.07902 21.3897 3 21.1989 3 21C3 20.8011 3.07902 20.6103 3.21967 20.4697C3.36032 20.329 3.55109 20.25 3.75 20.25H20.25C20.4489 20.25 20.6397 20.329 20.7803 20.4697C20.921 20.6103 21 20.8011 21 21ZM19.5 12H14.2097L15.6825 5.12906C15.7763 4.69171 15.7711 4.23892 15.6673 3.80383C15.5635 3.36875 15.3637 2.96238 15.0826 2.61447C14.8015 2.26656 14.4461 1.98592 14.0425 1.79309C13.6389 1.60026 13.1973 1.50012 12.75 1.5H11.25C10.8027 1.50012 10.3611 1.60026 9.9575 1.79309C9.5539 1.98592 9.19853 2.26656 8.9174 2.61447C8.63627 2.96238 8.4365 3.36875 8.3327 3.80383C8.2289 4.23892 8.22371 4.69171 8.3175 5.12906L9.79031 12H4.5C4.10218 12 3.72064 12.158 3.43934 12.4393C3.15804 12.7206 3 13.1022 3 13.5V17.25C3 17.6478 3.15804 18.0294 3.43934 18.3107C3.72064 18.592 4.10218 18.75 4.5 18.75H19.5C19.8978 18.75 20.2794 18.592 20.5607 18.3107C20.842 18.0294 21 17.6478 21 17.25V13.5C21 13.1022 20.842 12.7206 20.5607 12.4393C20.2794 12.158 19.8978 12 19.5 12Z",
    fill: "#716DCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliant);
export default __webpack_public_path__ + "static/media/compliant.41d47d2f0b779cad32ce7bf8eb28adf8.svg";
export { ForwardRef as ReactComponent };